//Components
import DataTable from '../../../Components/Util/DataTable/DataTable';

//Util
import api from "../api";
import {fields} from "../Util/jira";
import {secondsToJiraTimeString as timeString} from '../../../Util/time';
import {bootstrapDangerGrowl} from '../../../Util/growler';

export default {
    components: {
        DataTable
    },
    created() {
        const vm = this;
        
        api.getIssueTypes().then(
            issueTypes => { 
                vm.issueTypes = issueTypes;
                vm.mixinReady = true;
            },
            bootstrapDangerGrowl
        );
    },
    methods: {
        refresh() {
            if(this.filterType) {
                this.getSprint(this.filterType);
            }
        },
        getSprint(filterType) {
            const vm = this;
            vm.loading = true;

            const getBatch = (sprint = []) => {
                return new Promise((resolve,reject) => {
                    api.getIssues(filterType,sprint.length).then(
                        (response) => {
                            sprint = sprint.concat(response.issues);
                            
                            //if there are more issues to get. call ourself recursively.
                            if(sprint.length < response.total) {
                                getBatch(sprint).then(resolve).catch(reject);
                            } else {
                                resolve(sprint);
                            }
                        },
                        reject
                    );
                });
            };

            getBatch().then(vm.mapIssues,
                (error) => {
                    bootstrapDangerGrowl(error);
                    vm.loading = false;
                });
        },
        mapIssues(issues) {
            const vm = this;
            vm.issues = issues.map((issue) => {
                const issueModel = {
                    created: issue.fields.created,
                    updated: issue.fields.updated,
                    issueId: issue.key,
                    sprint: fields.sprint.parse(issue.fields[fields.sprint.name]),
                    type: vm.issueTypes.find(
                        type => type.id === issue.fields.issuetype.id
                    ).name,
                    summary: issue.fields[fields.summary.name],
                    title: issue.fields[fields.title.name],
                    //description: issue.fields.description,
                    status: issue.fields.status,
                    priority: issue.fields.priority,
                    assignee: issue.fields.assignee,
                    requestedBy: issue.fields[fields.requestedBy.name] || null,
                    size: issue.fields[fields.size.name] || null,
                    waitingFor: issue.fields[fields.waitingFor.name] || null,
                    DT_RowId: issue.key
                };
                
                if(vm.canReadTimeTracking) {
                    issueModel.estimatedSeconds = issue.fields.timeoriginalestimate;
                    issueModel.remainingSeconds = issue.fields.timeestimate;
                    issueModel.loggedSeconds = issue.fields.timespent;
                    
                    issueModel.estimated = timeString(issue.fields.timeoriginalestimate);
                    issueModel.remaining = timeString(issue.fields.timeestimate);
                    issueModel.logged = timeString(issue.fields.timespent);
                }
                
                return issueModel;
            });
            vm.loading = false;
        }
    },
    watch: {
        filterType(value) {
            this.getSprint(value);
        },
        loading(value) {
            if(value) {
                this.$emit('loading', true);
            } else {
                this.$emit('loading', false);
            }
        }
    },
    data() {
        return {
            issues: [],
            issueTypes: [],
            loading: false,
            mixinReady: false,
            canReadTimeTracking: false
        };
    },
    props: {
        filterType: {
            type: Number,
            default: null
        }
    }
};